import { Component } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { PagoService } from '../../../services/pago.service';
import { UserService } from '../../../services/user.service';
import { ChatLogService } from "../../../services/chatlog.service";
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modalpay',
  templateUrl: './modalpay.component.html',
  styleUrls: ['./modalpay.component.css'],
  providers: [UserService, PagoService,ChatLogService]
})
export class ModalpayComponent {
  additionalNote = '';
  idFather = 123;   
  fileType = 'RECEIPT';
  filesCount = 0;
  token: string;
  public submitting = false;
  public notesType = 'PAYMENT';
  public paymentID;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalpayComponent>,private _pagoService: PagoService,private _chatLogService: ChatLogService,private _userService: UserService
  ) {
    this.paymentID = data.id;
    this.token = this._userService.getToken();
  }
  


  onPrevious() {
    this.dialogRef.close();
  }
 
  onSubmit() {
    this.submitting = true;
    const payload: any = {
      id:     this.paymentID,
      status: 'Paid',
      action: 'Paid'
    };
    const fatherId  = `payment-${this.paymentID}`;
    if (this.additionalNote) payload.note = this.additionalNote;

    this._pagoService.changestatus(this.token, payload)
    .subscribe({
      next: () => {
        this.showToast('success', `Status changed to Paid`, 2000);
        this.submitting = false;
    
        if (this.additionalNote) {
          this._chatLogService.createchatforpayment(this.token, {
            father_id:   fatherId,
            message:     this.additionalNote,
            type:        'PAYMENT',
            paymentid:   this.paymentID,
            stepPayment: 0
          }).subscribe({
            next: () => this.dialogRef.close(true),
            error: () => this.dialogRef.close(true) 
          });
        } else {
          this.dialogRef.close(true);
        }
      },
      error: err => {
        this.showToast('error', 'Ops Something went wrong.', 2000);
        this.submitting = false;
      }
    });
  }

  showToast(type, title, timer) {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      }
    })
    Toast.fire({
      icon: type,
      title: title
    });
  }
}
